import { ChevronRightIcon } from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import styles from './styles.module.scss';

interface ActionButtonProps {
  className?: string;
  type?: 'darkFill' | 'darkOutline' | 'lightFill' | 'whiteFill' | 'redFill' | 'redOutline';
  size?: 'small' | 'medium' | 'large';
  content: string;
  rightIcon?: React.ReactNode;
  action?: () => void;
  disable?: boolean;
  href?: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
}

export function ActionButton({
  className,
  type = 'darkFill',
  size = 'medium',
  content,
  action,
  disable,
  href,
  icon = <ChevronRightIcon />,
  iconPosition = 'right',
}: ActionButtonProps) {
  return (
    <a
      href={href}
      className={clsx(
        className,
        styles.root,
        styles[type],
        size === 'small' ? styles.small : styles.medium,
        disable ? styles.disable : styles.noDisable,
        !icon ? styles.noIcon : iconPosition === 'left' ? styles.iconLeft : styles.iconRight
      )}
      onClick={disable ? () => {} : action}
    >
      {icon && iconPosition === 'left' && icon}
      <p className={clsx(styles.description, styles[type])}>{content}</p>
      {icon && iconPosition === 'right' && icon}
    </a>
  );
}
